import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { KEY } from 'utils/constants/storageKey';
import { autoLogin } from 'modules/account';
import { getUsers } from 'modules/user';
import { getAccountInfo, refreshAccessToken } from 'lib/api/account';
import { setAuthorization } from 'lib/api/account';
import store from 'storejs';
import { FROM } from 'utils/constants/storageKey';

/** 유저 자동 로그인 */
function useAutoLogin(isAuthenticated, users, refresh_token, from) {
  // * fcmtoken
  const dispatch = useDispatch();

  /** 자동로그인  */
  useEffect(() => {
    if (!isAuthenticated) {
      if (from) {
        // NOTE: 자사 외부서비스에서 위드비컨 B2C앱 웹뷰로 진입했을때 refresh token을 이용하여 자동로그인
        if (!refresh_token) return;
        refreshAccessToken(refresh_token).then(async (res) => {
          const newAccessToken = res.access_token;
          setAuthorization(newAccessToken);
          const { account: newAccount } = await getAccountInfo();
          store.set(KEY, {
            ...newAccount,
            access_token: newAccessToken,
            refresh_token,
          });
          dispatch(
            autoLogin({
              ...newAccount,
              access_token: newAccessToken,
              refresh_token,
            }),
          );
          sessionStorage.setItem(FROM, from);
          console.log('외부 자사 서비스 -> 위드비컨 앱 웹뷰 자동로그인 성공');
        });
      } else {
        const localStoredAccount = store.get(KEY);
        if (localStoredAccount) {
          dispatch(autoLogin(localStoredAccount));
        }
      }
    }
  }, [dispatch, isAuthenticated, refresh_token]);

  // 로그인 되었으나 users 데이터가 없으면 데이터 불러오기
  useEffect(() => {
    if (isAuthenticated && !users) {
      dispatch(getUsers());
    }
  }, [isAuthenticated, dispatch, users]);
}

export default useAutoLogin;
